module.exports = __webpack_public_path__ + "static/media/pathSecond.9b40fd51.svg";